import styled from 'styled-components';

export const ConfirmSignup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  text-align: center;
  padding-bottom: 120px;
`;
